import { GNOMUX_ROOT_ID } from "@db/objects";

/**
 * Build a breadcrumb path string by walking parentById.
 * Always starts with "/". Root-level items return "/".
 */
export function getObjectPath(
  id: string,
  parentById: Map<string, string>,
  namesById: Map<string, string>,
): string {
  const segments: string[] = [];
  let currentId = parentById.get(id);

  while (currentId && currentId !== GNOMUX_ROOT_ID) {
    const name = namesById.get(currentId);
    if (name) segments.unshift(name);
    currentId = parentById.get(currentId);
  }

  if (segments.length === 0) return "/";
  return `/${segments.join(" / ")}`;
}
